import { formatPrice } from "./price_formatter";

export function formatPriceBand(item) {
  return `de ${formatPrice(item.priceBandMin)} à ${formatPrice(item.priceBandMax)}`;
}
